<template>
    <el-button
        v-button.throttle="400"
    >
        <slot name="loading"></slot>
        <slot name="icon"></slot>
        <slot>Default</slot>
    </el-button>
</template>
